<template>
  <router-view />
</template>

<script>
export default {
  name: "scheduling",
};
</script>